import { render, staticRenderFns } from "./RoomScordForm.vue?vue&type=template&id=52bee18f&"
import script from "./RoomScordForm.vue?vue&type=script&lang=js&"
export * from "./RoomScordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports